module.exports = __webpack_public_path__ + "images/emoji/lips.1050d8af75ff1ee7fffc.png";